import React, { useRef, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useLanguage } from '../../context/LanguageContext';
import styles from './Hero.module.css';

const HERO_VIDEO = '/images/herovideo.mp4';

const Hero = () => {
  const { t } = useLanguage();
  const navigate = useNavigate();
  const videoRef = useRef(null);

  const handleStartClick = () => {
    navigate('/marketplace');
  };

  // Video 2,2 MB ve <source> ile işaretlemede dururken sayfanın geri kalanıyla
  // aynı anda iniyordu: mobilde şebekeyi doldurup en büyük boyamayı 7,5 sn'ye
  // itiyordu. src'yi ilk boyamadan sonra veriyoruz — o ana kadar 25 KB'lık
  // poster görünür, video hazır olunca sessizce üstüne oynamaya başlar.
  useEffect(() => {
    const video = videoRef.current;
    if (!video) return;

    let idleId = null;
    let cancelled = false;

    const startLoading = () => {
      if (cancelled || video.src) return;
      video.src = HERO_VIDEO;
      video.load();
      // Otomatik oynatma tarayıcı politikasıyla reddedilebilir; poster kalır.
      video.play().catch(() => {});
    };

    const schedule = () => {
      if (cancelled) return;
      idleId = window.requestIdleCallback
        ? window.requestIdleCallback(startLoading, { timeout: 2000 })
        : window.setTimeout(startLoading, 300);
    };

    if (document.readyState === 'complete') schedule();
    else window.addEventListener('load', schedule, { once: true });

    return () => {
      cancelled = true;
      window.removeEventListener('load', schedule);
      if (idleId == null) return;
      if (window.cancelIdleCallback) window.cancelIdleCallback(idleId);
      else window.clearTimeout(idleId);
    };
  }, []);

  return (
    <div className={styles.hero}>
      <div className={styles.videoContainer}>
              {/* poster: video ilk karesiyle aynı görsel, 25 KB. Videonun 2,2
                  MB'ı inene kadar hero boş kalıyordu ve LCP mobilde 6,7 sn'ye
                  çıkıyordu; poster ilk boyayı hemen üstlenir, video arkadan
                  gelip üstüne oturur. index.html'de ayrıca preload ediliyor. */}
              <video
                ref={videoRef}
                className={styles.heroVideo}
                autoPlay
                muted
                loop
                playsInline
                preload="none"
                poster="/images/herovideo-poster.webp"
                aria-label={t('hero.videoAlt')}
              >
                {/* src yok: yukarıdaki effect ilk boyamadan sonra atıyor. */}
                {t('hero.videoFallback')}
              </video>
        <div className={styles.videoOverlay}></div>
      </div>
      <div className={styles.container}>
        <div className={styles.content}>
          <h1 className={styles.title}>
            {t('hero.title')}
          </h1>
          <p className={styles.description}>
            {t('hero.subtitle')}
          </p>
          <button className={styles.button} onClick={handleStartClick}>
            {t('hero.cta')}
          </button>
        </div>
      </div>
    </div>
  );
};

export default Hero; 